__turbopack_context__.v({
  "body": "Cta-module__DwqRZq__body",
  "button": "Cta-module__DwqRZq__button",
  "heading": "Cta-module__DwqRZq__heading",
  "primary": "Cta-module__DwqRZq__primary",
  "secondary": "Cta-module__DwqRZq__secondary",
  "wrapper": "Cta-module__DwqRZq__wrapper",
});
